module.exports = __webpack_public_path__ + "media/Video-Header-Compressed.mp4";